import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from "vue";
import { useAppSettingsStore } from "@/services/pinia.service";


export default /*#__PURE__*/_defineComponent({
  __name: 'ToggleWithIcon',
  props: [
  "modelValue",
  "label",
  "checkedIcon",
  "uncheckedIcon",
  "dense",
  "size",
  "extraClass",
],
  emits: ["update:modelValue"],
  setup(__props, { emit }) {

const props = __props;



const appSettings = useAppSettingsStore().getAppSettings;
const value = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emit("update:modelValue", value);
  },
});

const finalSize = computed(() => {
  return props.size ? props.size : appSettings.size;
});

return (_ctx: any,_cache: any) => {
  const _component_q_toggle = _resolveComponent("q-toggle")!

  return (_openBlock(), _createBlock(_component_q_toggle, {
    modelValue: value.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((value).value = $event)),
    "checked-icon": __props.checkedIcon ? __props.checkedIcon : 'check',
    dense: __props.dense,
    color: "primary",
    "keep-color": "",
    size: finalSize.value,
    "unchecked-icon": __props.uncheckedIcon ? __props.uncheckedIcon : '',
    label: __props.label,
    class: _normalizeClass([_unref(appSettings).textBody, __props.extraClass])
  }, null, 8, ["modelValue", "checked-icon", "dense", "size", "unchecked-icon", "label", "class"]))
}
}

})